// extracted by mini-css-extract-plugin
module.exports = {"reportTabs":"Header_reportTabs__36M1Q","activeTab":"Header_activeTab__3PEsc"};